import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { AccountHierarchyResponse, AccountHierarchyStatus, DonutWidgetConfig, PaginationOptions, SPGroupLocation, SPLocationTotalSolutionGroupsExpandedData, SPViewFilterOptions } from '../../types/solution-participation-types';
import { FiltersService } from 'src/app/core/services/filters.service';
import { SolutionParticipationService } from '../../service/solution-participation.service';
import { MixpanelService } from 'src/app/core/services/mixpanel.service';
import { skip, Subscription } from 'rxjs';
import { ContractModel } from 'src/app/global/contract-filter-model';
import { CustomPaginator } from './CustomPaginationConfigurationLocations';
import { SPProductFilterOptions, groupByProducts, solutionParticipationProductFilter, SPLocationExpandedSolutionGroup } from '../../types/solution-participation-types';
import { Router } from '@angular/router';
import { SpExcelExportService } from '../../service/sp-excelexport.service';
import { CurrencyUomService } from 'src/app/core/services/currency-uom.service';
import { BrandingService } from 'src/app/core/services/branding.service';
import { FEATURE_FLAGS, FeatureFlags } from 'src/app/config/AppInitializer.factory';
import { WidgetBarGraphType } from '../widget-bar-graph/widget-bar-graph.types';

@Component({
    selector: 'app-solution-groups-table',
    templateUrl: './solution-groups-table.component.html',
    styleUrls: ['./solution-groups-table.component.scss'],
    providers: [
        { provide: MatPaginatorIntl, useValue: CustomPaginator() },
    ],
    standalone: false
})
export class SolutionGroupsTableComponent implements OnInit{

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('rightSection', { read: ElementRef }) rightSection!: ElementRef<any>;

  filters: ContractModel | undefined;
  filtersSubscription: Subscription | undefined;
  private currencySubscription: Subscription | undefined;


  isLoading: boolean = false;
  isModalDataLoading: boolean = true;
  searchTerm: string = '';

  totalLocationsCount: number = 0;
  locationsData: SPGroupLocation[] = [];
  filteredLocationsData: SPGroupLocation[] = [];

  pageSizeOptions = [5, 10, 25];
  paginationOptions: PaginationOptions = {
    limit: 25,
    page: 1,
    sortBy: "",
    sortOrder: "",
    tabSelected: "compliance"
  }
  solutionGroupNames: string[] = [];
  focusStartTime: Date | null = null;

  // Declared as object as it can be extended to other columns in the future
  sortDirections: { [key: string]: string } = {};
  sortBy: string = '';
  sortDirection = '';
  previousPageSize : number = 25;
  scrollPosition: number = 0;
  displayLoaderForFilterData : boolean = true;
  advancedFilterData: solutionParticipationProductFilter[] = [];
  productSelectedAdvancedFilters: SPProductFilterOptions = {
      "accountNumber": [],
      "accountName": [],
      "country": [],
      "state": [],
      "city": [],
      "zipCode": [],
      "productSku": [],
      "brand": [],
      "productName": [],
      "productGroup": []
  };
  filterGroupings: { [id: string]: string[] } = {
    'Account Information Filters': [
      'accountNumber',
      'accountName',
      'country',
      'state',
      'city',
      'zipCode'
    ],
    'Product Level Filters': [
      'productSku',
      'brand',
      'productName',
      'productGroup'
    ]
  };
  excludeKeys = ['productGroup','productName'];
  toggleAdvancedFilterSelection : boolean = false;
  productAdvancedFiltersSubscription: Subscription| undefined;
  data: any = [];
  exportAll: boolean = false;
  productsCount: number = 0;
  byDefaultSelectAllRows:boolean=false;
  filteredData: groupByProducts[] = [];

  selectedWidgetType: string = 'all';
  widgetTypeSubscription: Subscription | undefined;

  widgetTypes = [
    { value: 'rebate', label: 'Rebate', class: 'rebate' },
    { value: 'mpl', label: 'MPL', class: 'mpl' },
    { value: 'spl', label: 'SPL', class: 'spl' },
    { value: 'all', label: 'All', class: 'all' }
  ];

  // Single source of truth for the color used by both the radio swatch and the compliance slider fill
  private readonly widgetColorClassMap: { [key: string]: string } = {
    rebate: 'bg-[#813b9e]',
    mpl: 'bg-blue',
    spl: 'bg-neptune-color-secondary-800',
    all: 'bg-[#39B54A]'
  };

  chartConfig!: DonutWidgetConfig;
  eligibleForRebate: boolean = true;
  multipleContractsSelected: boolean = true;
  rebateComplianceTarget: number = 0;
  isOnlyAccountNumberFilterSelected: boolean = false;
  multipleRebatesExistForContract: boolean = false;

  // Variables for Total Solution Groups & Solution Group Modals for bottom left+right section
  currentSelectedSiteId: string = '';
  currentSelectedSiteName: string = '';
  totalSolutionGroupsPurchased: number = 0;
  showLocationViewModal: boolean = false;
  showTotalSolutionGroupsModal: boolean = false;
  showSolutionGroupModal: boolean = false;
  hoveredRowIndex: number | null = null;
  hoveredCellIndex: number | null = null;
  currentSelectedGroupForSite: string = '';
  totalSolutionGroupsForSiteData!: SPLocationTotalSolutionGroupsExpandedData;
  selectedSolutionGroupData: SPLocationExpandedSolutionGroup | undefined;
  selectedSGProductCount: number = 0;
  AccountHierarchyResponse!: AccountHierarchyResponse;

  fileDownload:boolean = false;

  widgetColumnName = {
    "rebate": "Rebate",
    "mpl": "MPL",
    "spl": "SPL",
    "all": "All"
  }
  //Used to hide radios for QSR/FRS
  isQsrFrsDivision: boolean = false;

  //Used to determine if the region selected is/are non-NA to hide radios
  isNonNAIMEARegion: boolean = false;

  // Used to determine if multiple regions are selected
  hasMultipleRegions: boolean = false;

  // Computed property - determines if Rebate/MPL/SPL columns should be hidden
  shouldHideRebateMplSplColumns: boolean = false;

  // Compliance, sales and cases
  tabSelected: string = 'compliance';
  currencyCode: string = '';

  // OneCustomer filters
  oneCustomerNameSubscription: Subscription | undefined;
  oneCustomerName: string = '';
  multipleHierarchiesSelectedMessage: string = BrandingService.multipleHierarchiesSelectedMessage;

  // Used to render placeholder rows/columns for the Neptune table skeleton loader
  skeletonRows: number[] = Array(5).fill(0);
  skeletonColumns: number[] = Array(4).fill(0);

  constructor(
    private _filterService: FiltersService,
    private _solutionParticipationService: SolutionParticipationService,
    private _mixpanelService: MixpanelService,
    private _router : Router,
    private renderer: Renderer2,
    private _spExcelexportService:SpExcelExportService,
    private _currencyUomService: CurrencyUomService,
    private _cdr: ChangeDetectorRef,
    @Inject(FEATURE_FLAGS) private _featureFlags: FeatureFlags,
  ) {

  }
  get isRefreshedSolutionParticipationUIEnabled() {
    return this._featureFlags.enableRefreshedSolutionParticipationUI;
  }


  async ngOnInit() {
    this.filtersSubscription = this._filterService.selectedFiltersObservable.subscribe(f => this.filters = f);
    this.oneCustomerNameSubscription = this._filterService.oneCustomerNameObservable.subscribe(name => {
      this.oneCustomerName = name;
    });
    if (this.filters != undefined) {
      this.isLoading = true;
      this._solutionParticipationService.setTableDataLoading(true);

      this.isOnlyAccountNumberFilterSelected = ((this.filters?.accts?.length ?? 0) >= 1  &&
                                               (this.filters?.topLevelContractGroup?.length ?? 0) === 0 &&
                                               (this.filters?.secondLevelContractFilter?.length ?? 0)) === 0;

      //If Only Account Number filter is/are selected, check the account numbers belongs same hierarchy or not.
      // If they belong to different hierarchy, show the message to user.
      if(this.isOnlyAccountNumberFilterSelected) {
        this.AccountHierarchyResponse = await this._solutionParticipationService.ValidateAccountHierarchy();
        this._solutionParticipationService.setAccountHierarchyData(this.AccountHierarchyResponse);
      }
      //Set hide radios to true if the selected division is FRS or QSR
      this.isQsrFrsDivision = this.filters?.division === 'FRS' || this.filters?.division === 'QSR';

      //Check if the selected region/s is non-NA/IMEA to determine if we need to hide the radios
      this.isNonNAIMEARegion = this.filters?.regions ? !this.filters.regions.some(region => ['NA', 'IMEA'].includes(region)) : false;

      this.hasMultipleRegions = (this.filters?.regions?.length ?? 0) > 1;
      this.shouldHideRebateMplSplColumns = this.isQsrFrsDivision || this.isNonNAIMEARegion || this.hasMultipleRegions;

      // Load saved pagination state
      this.paginationOptions = this._solutionParticipationService.getPaginationState();
      //Load Sorting State
      this.sortDirections = this._solutionParticipationService.getSGLSortingState().sortDirections;
      this.sortBy = this._solutionParticipationService.getSGLSortingState().sortBy;
      this.sortDirection = this._solutionParticipationService.getSGLSortingState().sortDirection;

      // Get the currency symbol based on the selected region
      this.getCurrencyForRegion();

      //Assign multiple contracts selected flag
      if(this?.AccountHierarchyResponse?.status === AccountHierarchyStatus.LinkedToMultipleHierarchies)
        this.multipleContractsSelected = true;
      else
        this.multipleContractsSelected = ((this.filters?.topLevelContractGroup?.length ?? 0) > 1 || (this.filters?.secondLevelContractFilter?.length ?? 0) > 1);

      if (this.paginator) {
        this.paginator.pageIndex = this.paginationOptions.page - 1;
        this.paginator.pageSize = this.paginationOptions.limit;
      }

      // Advanced filters subscription
      if (this._solutionParticipationService.getLocationViewAdvancedFilters()) {
        this.productAdvancedFiltersSubscription = this._solutionParticipationService.getLocationViewAdvancedFilters().subscribe(
          advFilter => this.productSelectedAdvancedFilters = advFilter
        );
      }

      this.byDefaultSelectAllRows = true;
      // Set Advanced Filters
      this.displayLoaderForFilterData = true;
      this.advancedFilterData = await this.getAdvancedFilterData();
      this.displayLoaderForFilterData = false;

      if (this.advancedFilterData == undefined) this.advancedFilterData = [];

      this.multipleRebatesExistForContract = await this._solutionParticipationService.hasDataWithMultipleRebateAgreements();
      this._solutionParticipationService.setMultipleRebatesExistForContract(this.multipleRebatesExistForContract);

      //Check to see if we've done the first load
      const firstLoadComplete = this._solutionParticipationService.getSPGroupFirstLoadComplete();

      // Get the previous solutionGroupsResponseData from the service on tab change from the subject stream.
      let solutionGroupsResponseData = this._solutionParticipationService.getAllSPGroupData();

      //On firstLoad, set the widgetType to 'all' and mark the first load as completed
      if(!firstLoadComplete) {

        if(!this.multipleContractsSelected && this.oneCustomerName === '' && !this.shouldHideRebateMplSplColumns) {
          //Get rebate, mpl, spl widget data, as well as the solutionGroupsByLocation ('All' data) in parallel
          
          // For IMEA, Rebate/MPL/SPL data should not be displayed when the feature flag is disabled.
          // Since the API returns data through its join with sales data, we skip the API call
          // and return an empty object instead.
          const shouldCallApi = this.shouldCallApi('rebate');

          const widgetPromises = shouldCallApi
            ? [
                this._solutionParticipationService.getSPRebateWidgetData('rebate', this.productSelectedAdvancedFilters),
                this._solutionParticipationService.getSPProductWidgetData('mpl', this.productSelectedAdvancedFilters),
                this._solutionParticipationService.getSPProductWidgetData('spl', this.productSelectedAdvancedFilters)
              ]
            : [Promise.resolve({}), Promise.resolve({}), Promise.resolve({})];

          const [rebateWidgetData, mplWidgetData, splWidgetData, solutionGroupsResponse] = await Promise.all([
            ...widgetPromises,
            this._solutionParticipationService.getSolutionGroupsByLocation(this.selectedWidgetType,this.paginationOptions,this.productSelectedAdvancedFilters)
          ]);

          //Set as observables
          this._solutionParticipationService.setRebateWidgetData(rebateWidgetData);
          this._solutionParticipationService.setMPLWidgetData(mplWidgetData);
          this._solutionParticipationService.setSPLWidgetData(splWidgetData);
          this._solutionParticipationService.setAllSPGroupData(solutionGroupsResponse);

          solutionGroupsResponseData = solutionGroupsResponse;

          //Depending on what data is available, set the radio button and widget type to the appropriate selection
          //And set what widget data shows when 'All' is selected
          if (rebateWidgetData?.data?.complianceTarget != null && rebateWidgetData?.data?.complianceTarget !== 0) {
            this._solutionParticipationService.setSelectedRadioButton("rebate");
            this.selectedWidgetType = "rebate";
            this.rebateComplianceTarget = rebateWidgetData?.data?.complianceTarget;
          } else if(mplWidgetData?.data?.productListCount != null && mplWidgetData?.data?.productListCount !== 0 ){
            this._solutionParticipationService.setSelectedRadioButton("mpl");
            this.selectedWidgetType = "mpl";
          } else if(splWidgetData?.data?.productListCount != null && splWidgetData?.data?.productListCount !== 0 ){
            this._solutionParticipationService.setSelectedRadioButton("spl");
            this.selectedWidgetType = "spl";
          } else if (solutionGroupsResponse?.data?.spGroupLocations != null && solutionGroupsResponse?.data?.spGroupLocations !== 0) {
            //if there is sales data but no rebate, mpl, spl agreements, set the widget type to 'all'
            this._solutionParticipationService.setSelectedRadioButton("all");
            this.selectedWidgetType = "all";
          } else{
            //if there is no data at all, radio button is 'all', and widgetType is 'noData'
            this._solutionParticipationService.setSelectedRadioButton("all");
            this.selectedWidgetType = "all";
          }
        } else {
          //If multiple contracts are selected or OneCustomerFilters are provided,
          // set the widget type to 'all' and get the solutionGroupsResponseData for 'all' widget type
          this._solutionParticipationService.setSelectedRadioButton("all");
          this.selectedWidgetType = "all";
        }

        //Set default sorting and pagination options
        this.setDefaultSortDirections()
        this.setDefaultPaginationOptions();

        // fetch the solutionGroupsResponseData for the selectedWidgetType here to display on first load
        solutionGroupsResponseData = await this.getSolutionGroupsResponseData(this.selectedWidgetType, this.productSelectedAdvancedFilters);
        this._solutionParticipationService.setAllSPGroupData(solutionGroupsResponseData);
        this._solutionParticipationService.setSPGroupFirstLoadComplete(true);

        //Re-fetch data when currency changes
        this.currencySubscription = this._currencyUomService.selectedCurrency$.pipe(skip(1)).subscribe(async () => {
          this.currencyCode = '';
          this.isLoading = true;
          this._solutionParticipationService.setTableDataLoading(true);
          this._currencyUomService.setCurrencyLoading(true);

          // fetch the solutionGroupsResponseData for the selectedWidgetType here to display on first load
          solutionGroupsResponseData = await this.getSolutionGroupsResponseData(this.selectedWidgetType, this.productSelectedAdvancedFilters);

          this._currencyUomService.setCurrencyLoading(false);

          this._solutionParticipationService.setAllSPGroupData(solutionGroupsResponseData);

          this.initializeData(solutionGroupsResponseData);

          this.isLoading = false;

          this.getCurrencyForRegion();
          this._cdr.detectChanges();
        });

      } else {
        this.selectedWidgetType = this._solutionParticipationService.getSelectedRadioButton();
      }

      if(!this.shouldHideRebateMplSplColumns && this.oneCustomerName === '' && !this.multipleContractsSelected) {
        // Set eligibleForRebate flag here
        // For IMEA, Rebate/MPL/SPL data should not be displayed when the feature flag is disabled.
        // Since the API returns data through its join with sales data, we skip the API call
        // and return an empty object instead.
        const shouldCallApi = this.shouldCallApi("rebate");

        const rebateWidgetData = shouldCallApi ? await this._solutionParticipationService.getSPRebateWidgetData("rebate", this.productSelectedAdvancedFilters) : {};
        this.eligibleForRebate = rebateWidgetData?.data?.complianceTarget !== 0;
      }

      this.widgetTypeSubscription = this._solutionParticipationService.selectedRadioButtonObservable$
      .pipe(skip(1)).subscribe(radioButton =>
        this.selectedWidgetType = radioButton
      );

      // Set Donut chart config options for widget charts
      this.setDonutChartConfig();

      this.initializeData(solutionGroupsResponseData);
      window.scrollTo(0, 0);
    } else {
      alert('Please apply filters before navigating to Solution Participation')
      this._router.navigate(['/filter']);
    }
  }

  private setDonutChartConfig() {
    this.chartConfig = {
      responsive: true,
      maintainAspectRatio: false,
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    }
  }

  public get showTableLoader(): boolean {
    return this.isLoading && !this.shouldShowMessageInsteadOfTable();
  }

  /**
   * Determines whether a message should be shown instead of the table data based on the widget type and other conditions.
   * @param widgetType 
   * @returns 
   */
  private shouldShowMessageInsteadOfTable(widgetType = this.selectedWidgetType): boolean {
    // Show message if multiple contracts are selected and the widget type is not 'all'.
    // Show message if only one contract is selected, the widget type is 'rebate', and either multiple rebates exist for the contract or the contract is not eligible for rebate.
    return (this.multipleContractsSelected && widgetType !== 'all') ||
      (!this.multipleContractsSelected && widgetType === 'rebate' &&
      (this.multipleRebatesExistForContract || !this.eligibleForRebate));
  }

  private async getSolutionGroupsResponseData(widgetType = this.selectedWidgetType, advProductFilters = this.productSelectedAdvancedFilters) {

    // For IMEA, Rebate/MPL/SPL data should not be displayed when the feature flag is disabled.
    // Since the API returns data through its join with sales data, we skip the API call
    // and return an empty object instead.
    const shouldCallApi =   this.shouldCallApi(widgetType);
    if(!shouldCallApi) {
      return {};
    }

    if (this.shouldShowMessageInsteadOfTable(widgetType)) {
      return {
        data: null
      };
    }

    return await this._solutionParticipationService.getSolutionGroupsByLocation(widgetType, this.paginationOptions, advProductFilters);
  }

  async getSGLocationsData(advProductFilters: SPProductFilterOptions) {
    this.isLoading = true;
    this._solutionParticipationService.setTableDataLoading(true);
    this.filtersSubscription = this._filterService.selectedFiltersObservable.subscribe(f => this.filters = f);

    if (this.filters != undefined) {
      const solutionGroupsResponse = await this.getSolutionGroupsResponseData(this.selectedWidgetType, advProductFilters);
      this._solutionParticipationService.setAllSPGroupData(solutionGroupsResponse);
      this.initializeData(solutionGroupsResponse);
    }
  }

  initializeData(solutionGroupsResponse: any) {
    this.eligibleForRebate = true; // Reset elgiible for rebate flag
    this.locationsData = solutionGroupsResponse?.data?.spGroupLocations ?? [];
    this.filteredLocationsData = this.locationsData; // Initialize filtered data

    // Initialize modal variables
    this.initializeModalData();

    this.totalLocationsCount = solutionGroupsResponse?.data?.totalCount ?? 0;
    this.solutionGroupNames = solutionGroupsResponse?.data?.solutionGroups ?? [];

    this.isLoading = false;
    this._solutionParticipationService.setTableDataLoading(false);
    // Use setTimeout to ensure DOM update before restoring scroll
    setTimeout(() => {
      // Check if rightSection is defined and has a nativeElement property, only then scroll to previous scrolled position
      if (this.rightSection && this.rightSection.nativeElement) {
        this.checkScrollbar();

        this.rightSection.nativeElement.scrollTo({
          left: this.scrollPosition,
          behavior: 'smooth'
        });
      }
    }, 2000);
  }

  initializeModalData(solutiongroup = '') {
    this.currentSelectedSiteId = '';
    this.currentSelectedSiteName = '';
    this.totalSolutionGroupsPurchased= 0;
    this.currentSelectedGroupForSite= solutiongroup;
    this.totalSolutionGroupsForSiteData = {} as SPLocationTotalSolutionGroupsExpandedData;
    this.selectedSolutionGroupData = undefined;
    this.selectedSGProductCount= 0;
  }

  onPageChange(event: PageEvent) {
    if(this.previousPageSize !== event.pageSize) {
      this.paginator.pageIndex = 0;
      this.previousPageSize = event.pageSize;

      // Clear cache when page size changes as all cached pages will be invalid
      this._solutionParticipationService.clearCache();
    }
    this.updatePageData(this.paginator.pageIndex, event.pageSize);
  }

  // Neptune custom paginator (Tailwind only, no mat-paginator): reuses paginationOptions/totalLocationsCount/updatePageData
  get totalPages(): number {
    return Math.max(1, Math.ceil(this.totalLocationsCount / this.paginationOptions.limit));
  }

  get startRecord(): number {
    return this.totalLocationsCount === 0 ? 0 : (this.paginationOptions.page - 1) * this.paginationOptions.limit + 1;
  }

  get endRecord(): number {
    return Math.min(this.paginationOptions.page * this.paginationOptions.limit, this.totalLocationsCount);
  }

  get isFirstPage(): boolean {
    return this.paginationOptions.page <= 1;
  }

  get isLastPage(): boolean {
    return this.paginationOptions.page >= this.totalPages;
  }

  firstPage(): void {
    if (this.isFirstPage) { return; }
    this.updatePageData(0, this.paginationOptions.limit);
  }

  previousPage(): void {
    if (this.isFirstPage) { return; }
    this.updatePageData(this.paginationOptions.page - 2, this.paginationOptions.limit);
  }

  nextPage(): void {
    if (this.isLastPage) { return; }
    this.updatePageData(this.paginationOptions.page, this.paginationOptions.limit);
  }

  lastPage(): void {
    if (this.isLastPage) { return; }
    this.updatePageData(this.totalPages - 1, this.paginationOptions.limit);
  }

  onPageSizeChange(newSize: number): void {
    if (this.previousPageSize !== newSize) {
      this.previousPageSize = newSize;
      // Clear cache when page size changes as all cached pages will be invalid
      this._solutionParticipationService.clearCache();
    }
    this.updatePageData(0, newSize);
  }

  async updatePageData(pageIndex: number, pageSize: number) {
    this.paginationOptions = {
      ...this.paginationOptions,
      page: pageIndex + 1,
      limit: pageSize
    };
    await this.getSGLocationsData(this.productSelectedAdvancedFilters);
  }

  toggleSortDirection(column: string) {
    // Store current scroll position before sorting
    this.scrollPosition = this.rightSection.nativeElement.scrollLeft;

    // Initialize the column in sortDirections if it doesn't exist
    if (!this.sortDirections[column]) {
      this.sortDirections[column] = 'asc';
    } else {
      // Toggle between 'asc' and 'desc' if sorting the same column twice in a row
      if(this.sortBy === column) {
        this.sortDirections[column] =
          this.sortDirections[column] === 'asc' ? 'desc' : 'asc';
      }
      //else do nothing, because the hover will apply the opposite sort direction that would be applied (which is weird UX)
    }

    // Update sort parameters
    this.sortBy = column;
    this.sortDirection = this.sortDirections[column];

    // Store sorting state
    this._solutionParticipationService.updateSGLSortingState({
      sortDirections: this.sortDirections,
      sortBy: this.sortBy,
      sortDirection: this.sortDirection
    });

    // Clear cache when sort changes as all cached pages will be invalid
    this._solutionParticipationService.clearCache();

    this.sortLocationsData(this.sortBy, this.sortDirection);
  }

  sortLocationsData(sortValue: string, direction: string) {
    // Track Mixpanel Event
    this._mixpanelService.track(`Solution Groups Locations - Column ${sortValue} Sorted`, {
      "Sort Direction": direction,
      "Sorted Column Name": sortValue
    });

    this.paginationOptions = {
      ...this.paginationOptions,
      sortBy: sortValue,
      sortOrder: direction,
      page: 1,
    };

    // Neptune view has no mat-paginator ViewChild, so guard against undefined
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.updatePageData(0, this.paginationOptions.limit);
  }

  async getAdvancedFilterData() {
    return await this._solutionParticipationService.getSummaryDetailsAdvFilters();
  }

  async onSelectedFiltersChange(selectedFilters:{ [id: string]: string[] }) {
    this._solutionParticipationService.setLocationViewAdvancedFilters(selectedFilters as SPViewFilterOptions);
    //Reset sorting and pagination options when applying advanced filters
    this.setDefaultPaginationOptions();
    this.setDefaultSortDirections();
    if (this.filters?.period != undefined) {
      // Always get solution group locations data regardless of division type
      const getSGLocationsPromise = this.getSGLocationsData(this.productSelectedAdvancedFilters);

      if (!this.shouldHideRebateMplSplColumns) {
        // For IMEA, Rebate/MPL/SPL data should not be displayed when the feature flag is disabled.
        // Since the API returns data through its join with sales data, we skip the API call
        // and return an empty object instead.
        const shouldCallApi = this.shouldCallApi('rebate');

        const [rebateWidgetData, mplWidgetData, splWidgetData] = shouldCallApi
          ? await Promise.all([
              this._solutionParticipationService.getSPRebateWidgetData("rebate", this.productSelectedAdvancedFilters),
              this._solutionParticipationService.getSPProductWidgetData("mpl", this.productSelectedAdvancedFilters),
              this._solutionParticipationService.getSPProductWidgetData("spl", this.productSelectedAdvancedFilters),
              getSGLocationsPromise
            ])
          : [{}, {}, {}, await getSGLocationsPromise];

        // Set observables to update widget
        this._solutionParticipationService.setRebateWidgetData(rebateWidgetData);
        this._solutionParticipationService.setMPLWidgetData(mplWidgetData);
        this._solutionParticipationService.setSPLWidgetData(splWidgetData);
      } else {
        // For QSR/FSR divisions, just await the SG locations data (already being fetched)
        await getSGLocationsPromise;
      }
    }
  }

  async onSearch(input: string) {
    if (input.length >= 3) {
      this.filteredLocationsData = this.locationsData.filter((location) =>
        location.siteName.toUpperCase().includes(input.toUpperCase())
      );
    } else {
      this.filteredLocationsData = this.locationsData;
    }
    this.paginator.pageIndex = 0; // Reset to the first page
  }

  public onSearchFocus(){
    this.focusStartTime = new Date();
  }

  public onSearchBlur(){
    if (this.focusStartTime) {
      const focusDuration = (new Date()).getTime() - this.focusStartTime.getTime();
      // if focus duration is 10 seconds or more and search term is not empty fire mixpanel event
      if (focusDuration >= 10000 && this.searchTerm != '') {
        this.trackMixPanelEventForByLocationDetailsTable("Solution Groups by Locations - Search Functionality used", {textSearched: this.searchTerm});
      }
      this.focusStartTime = null;
    }
  }

  async onWidgetTypeChange(type: string) {
    this.selectedWidgetType = type;
    this.isLoading = true;
    this._solutionParticipationService.setTableDataLoading(true);

    this._solutionParticipationService.setSelectedRadioButton(type);
    //Reset pagination
    this.setDefaultPaginationOptions();
    //Reset Sorting state
    this.setDefaultSortDirections();

    // Restrict API calls when current widget state should show a message instead of table data.
    const solutionGroupsResponse = await this.getSolutionGroupsResponseData(this.selectedWidgetType, this.productSelectedAdvancedFilters);

    this.trackMixPanelEventForByLocationDetailsTable(`Solution Groups Locations - Radio Button Changed`)

    //Set data to the subject on change of radio
    this._solutionParticipationService.setAllSPGroupData(solutionGroupsResponse);
    this.initializeData(solutionGroupsResponse);

  }

  public async openLocationSolutionsModal(siteId: string, siteName:string, totalSolutionGroupsPurchased: number, widgetType: string, leftSection: boolean = true, selectedSolutionGroup: string = '') {
    this.showLocationViewModal = true;
    // Open modals and show loaders
    if(leftSection) {
      this.showTotalSolutionGroupsModal = true;
    } else {
      this.showSolutionGroupModal = true;
    }

    // Get updated data if the siteId is different
    if(siteId !== this.currentSelectedSiteId) {
      this.isModalDataLoading = true;
      this.currentSelectedSiteId = siteId;
      this.currentSelectedSiteName = siteName;
      this.totalSolutionGroupsPurchased = totalSolutionGroupsPurchased;
      this.currentSelectedGroupForSite = '';

      const locationSolutionGroupsResponse = await this._solutionParticipationService.getSPTotalSolutionGroupsExpandedData(siteId, widgetType);
      const locationSolutionGroupData = (locationSolutionGroupsResponse?.data ?? locationSolutionGroupsResponse ?? {
        siteId,
        totalSolutionGroups: 0,
        solutionGroups: []
      }) as SPLocationTotalSolutionGroupsExpandedData;

      this.totalSolutionGroupsForSiteData = this.appendMissingNotPurchasedSolutionGroups(locationSolutionGroupData);
      this._solutionParticipationService.setTotalSolutionGroupsForSiteData(this.totalSolutionGroupsForSiteData);

      this.isModalDataLoading = false;
    }

    // Filter data for different solution group is selected but site Id remains same
    if(selectedSolutionGroup !== this.currentSelectedGroupForSite) {
      this.filterSiteDataForSolutionGroup(selectedSolutionGroup);
    }
  }

  public closeSolutionModal() {
    this.showLocationViewModal = false;
    this.showTotalSolutionGroupsModal = false;
    this.showSolutionGroupModal = false;
    document.body.style.overflow = 'auto';
  }

  private filterSiteDataForSolutionGroup(solutionGroup: string) {
    this.isModalDataLoading = true;
    this.currentSelectedGroupForSite = solutionGroup;
    // Filter product data for new solution group from totalSolutionGroupsForSiteData
    this.selectedSolutionGroupData = this.totalSolutionGroupsForSiteData?.solutionGroups.find(group => group.solutionGroup === solutionGroup) || {} as SPLocationExpandedSolutionGroup;
    this.selectedSGProductCount = this.selectedSolutionGroupData.countOfProducts ?? 0;
    this.isModalDataLoading = false;
  }


  private appendMissingNotPurchasedSolutionGroups(siteData: SPLocationTotalSolutionGroupsExpandedData): SPLocationTotalSolutionGroupsExpandedData {
    const existingSolutionGroups = [...(siteData?.solutionGroups ?? [])];
    const existingSolutionGroupNames = new Set(existingSolutionGroups.map(group => group.solutionGroup));

    const missingSolutionGroups = this.solutionGroupNames
      .filter(solutionGroupName => !existingSolutionGroupNames.has(solutionGroupName))
      .map(solutionGroupName => this.createSyntheticSolutionGroup(solutionGroupName));

    return {
      siteId: siteData?.siteId ?? this.currentSelectedSiteId,
      totalSolutionGroups: existingSolutionGroups.filter(group => group.isPurchased).length,
      solutionGroups: [...existingSolutionGroups, ...missingSolutionGroups]
    };
  }

  private createSyntheticSolutionGroup(solutionGroup: string): SPLocationExpandedSolutionGroup {
    return {
      countOfProducts: 0,
      otherDistributor: '',
      solutionGroup,
      totalSalesAmt: 0,
      isPurchased: false,
      products: []
    };
  }


  private setDefaultSortDirections(widgetType = this.selectedWidgetType){
    if(widgetType === 'all'){
      this.sortBy = "countPurchased";
      this.sortDirection = "desc";
      this.sortDirections = {"countPurchased":"desc"};
    }else{ //rebate, mpl, spl
      this.sortBy = "countPurchased";
      this.sortDirection = "asc";
      this.sortDirections = {"countPurchased":"asc"};
    }

    this._solutionParticipationService.updateSGLSortingState({
      sortDirections: this.sortDirections,
      sortBy: this.sortBy,
      sortDirection: this.sortDirection
    });
  }

  private setDefaultPaginationOptions(widgetType = this.selectedWidgetType){
    if(widgetType === 'all'){
      this.paginationOptions = {
        ...this.paginationOptions,
        sortBy: "countPurchased",
        sortOrder: "desc",
        page: 1,
        tabSelected: this.tabSelected
      };
    }else{ //rebate, mpl, spl
      this.paginationOptions = {
        ...this.paginationOptions,
        sortBy: "countPurchased",
        sortOrder: "asc",
        page: 1,
        tabSelected: this.tabSelected
      };
    }
  }

  // Function to get the formatted middle text Eg: "10/11"
  getCustomMiddleText(location: SPGroupLocation, solutionsCount: number, selectedWidgetType: string): string {
    return selectedWidgetType == "rebate" ? `${location.count}/${solutionsCount}` : `${location.greenCount}/${solutionsCount}`;
  }

  //Function to get the widget column name
  getWidgetColumnName(widgetType: string) {
    return this.widgetColumnName[widgetType as keyof typeof this.widgetColumnName];
  }

  //Function to get the widget colors based on widget type
  getWidgetColors(widgetType: string): string[] {
    const widgetColors: { [key: string]: string[] } = {
      rebate: ["#813B9E", "#F6F6F6"],
      mpl: ["#006BD3", "#F6F6F6"],
      spl: ["#1AA5E0", "#F6F6F6"]
    };
    return widgetColors[widgetType] || ["#000000", "#FFFFFF"];
  }

  // Tailwind background class for a given widget type, used by the radio swatch
  getWidgetColorClass(widgetType: string): string {
    return this.widgetColorClassMap[widgetType] || '';
  }

  // Maps the selected radio widget type to the compliance bar graph's resolver key
  private readonly locationBarGraphTypeMap: { [key: string]: WidgetBarGraphType } = {
    rebate: WidgetBarGraphType.LocationRebateCompliance,
    mpl: WidgetBarGraphType.LocationMplCompliance,
    spl: WidgetBarGraphType.LocationSplCompliance
  };

  getLocationBarGraphType(widgetType: string): WidgetBarGraphType {
    return this.locationBarGraphTypeMap[widgetType] ?? WidgetBarGraphType.LocationMplCompliance;
  }

  trackByWidgetTypeValue(_index: number, type: { value: string }): string {
    return type.value;
  }

  // Add a class to the right section if it has scrollbar so that row styles are intact
  checkScrollbar() {
    const div = this.rightSection.nativeElement;
    if (this.hasScrollbar(div)) {
      this.renderer.addClass(div, 'no-scrollbar');
    } else {
      this.renderer.removeClass(div, 'no-scrollbar');
    }
  }

  hasScrollbar(element: HTMLElement): boolean {
    return element.scrollWidth <= element.clientWidth;
  }

  // TODO : Move excel download to backend as it might fail for larger datasets
  async exportAllToExcel(){
    if(this.multipleContractsSelected && this.selectedWidgetType != 'all'){
      alert('Please select "All" widget type to export data for multiple contracts');
      return;
    }
    this.fileDownload = true;

    try {
      const response = await this._solutionParticipationService.exportSolutionGroupsData( this.selectedWidgetType, this.paginationOptions, this.productSelectedAdvancedFilters);

      if (!response?.data?.size || response.data.size === 0) {
        alert('No data available for export.');
        return;
      }

      const fileData = response.data;

      // Generate filename
      const widgetName = this.getWidgetColumnName(this.selectedWidgetType);
      const currentDate = new Date().toISOString().slice(0, 19).replace(/[-T:/]/g, '');
      const fileName = `EBR_${widgetName}Location_Details${currentDate}.xlsx`;

      this._spExcelexportService.executeBrowserDownload(fileData, fileName);

      // Track Mixpanel Event
      this.trackMixPanelEventForByLocationDetailsTable(`Solution Groups Locations - Exported ${this.selectedWidgetType} to Excel`);
    } catch (error) {
      console.error('Error exporting solutions group data:', error);
      alert('An error occurred while exporting data. Please try again.');
    } finally {
      this.fileDownload = false;
    }
  }

  changeTab(tab: string) {
    this.tabSelected = tab;

    // Update pagination options to change tab name
    this.paginationOptions = {
      ...this.paginationOptions,
      tabSelected: tab
    };

    // Set default sorting and pagination options for the selected widget type
    this.setDefaultSortDirections(this.selectedWidgetType);
    this.sortLocationsData(this.sortBy, this.sortDirection);

    this.trackMixPanelEventForByLocationDetailsTable(`Solution Groups Locations - ${this.tabSelected} Tab Clicked`);

    this.getCurrencyForRegion();
  }

  private trackMixPanelEventForByLocationDetailsTable(eventName: string, properties: any | undefined = {}) {
    this._mixpanelService.track(eventName, {
      division: this.filters?.division,
      dataView: this.filters?.dataView,
      regionSelected: this.filters?.regions,
      countriesSelected: this.filters?.countries,
      H5s: this.filters?.topLevelContractGroup,
      H7s: this.filters?.secondLevelContractFilter,
      acctsSelected: this.filters?.accts,
      periodSelected: this.filters?.period,
      "Custom Date Range": this.filters?.dateRange,
      widgetType: this.selectedWidgetType,
      ...properties
    });
  }

  getCurrencyForRegion() {
    this.currencyCode = this._currencyUomService.getCurrencyCode();
  }

  // Data is not currently available for Rebate/MPL/SPL widgets for the Institutional division in IMEA.
  // Since the API returns data through its join with sales data, we skip the API call
  // and return an empty object instead.
  private shouldCallApi(widgetType: string): boolean {
    const isIMEAInstitutional = (this.filters?.regions?.includes('IMEA') ?? false) &&
      this.filters?.division === 'Institutional';

    if (!isIMEAInstitutional || widgetType === 'all') {
      return true; // 'all' widget type is unaffected by the IMEA Institutional restriction
    }

    return this._featureFlags.enableSpRebateMPLSPLWidgetsForIMEAInstitutional;
}

  ngOnDestroy(): void {
    this.filtersSubscription?.unsubscribe();
    this.widgetTypeSubscription?.unsubscribe();
    this.productAdvancedFiltersSubscription?.unsubscribe();
    this.currencySubscription?.unsubscribe();
  }
}
